<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/subGrupoProduto"> Cadastro/Produtos e Serviços/SubGrupos </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col col="6">
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
          <v-col col="6">
            <v-select
              v-model="grupoSelected"
              :items="findGruposAtivos"
              label="Grupo *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Grupo é obrigatório']"
              required
            >
            </v-select>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox v-model="subGrupoProduto.ativo" label="Ativo" :readonly="readOnly"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/subGrupoProduto" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/subGrupoProduto" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { editarSubGrupoProdutoAsync } from "../../../services/grupoProdutoService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarSubGrupo",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    grupoSelected: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("grupoProduto", ["subGrupoProduto", "gruposProduto"]),

    findGruposAtivos() {
      return this.gruposProduto.filter((g) => {
        return g.ativo === true;
      });
    }

  },
  methods: {
    ...mapActions("grupoProduto", ["atualizarGruposProduto", "updateSubGrupoProduto"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarSubGrupoProdutoAsync(
          this.subGrupoProduto.id,
          this.descricao,
          this.grupoSelected.id,
          this.subGrupoProduto.ativo
        );
        if (!resposta || resposta.message || resposta.Message) {
          this.overlay = false;
          this.$alert(resposta && (resposta.message || resposta.Message) ? resposta.message || resposta.Message : "", "Descupe, falha na operação!", "error");
        } else {
          this.updateSubGrupoProduto(this.mountObjSubGrupoProduto(resposta));
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/subGrupoProduto");
        }
      }
    },
    mountObjSubGrupoProduto(subGrupoSalvo) {
      return {
        ...subGrupoSalvo,
        grupoProduto: this.grupoSelected.descricao,
      };
    },
    findGrupo(grupoId) {
      return this.gruposProduto.find((g) => g.id === grupoId);
    },
    doAjax() {
      this.atualizarGruposProduto();
    },
  },
  created: function () {
    this.doAjax();
    this.readOnly = !getUserPermission(6);
    this.descricao = this.subGrupoProduto.descricao;
    this.grupoSelected = this.findGrupo(this.subGrupoProduto.idGrupo);
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>
